import SubmitButton from './SubmitButton/SubmitButton';
import Checkbox from './Checkbox/Checkbox';
import FilterButton from './FilterButton/FilterButton';
import FilterTag from './FilterTag/FilterTag';
import Pad from './Pad/Pad';
import Datepicker from './Datepicker/Datepicker';
import GlobalErrorPlug from './GlobalErrorPlug/GlobalErrorPlug';
import Carousel from './Carousel/Carousel';
import CarouselButton from './CarouselButton/CarouselButton';
import Loader from './Loader/Loader';
import useFade from './hooks/useFade/useFade';
import useMediaQuery from './hooks/useMediaQuery';
import capitalizeFirstLetter from './utils/capitalizeFirstLetter';
import displayPrice from './utils/displayPrice';
import Info from './Info/Info';
import Banner from './Banner/Banner';
import NextTrips from './NextTrips/NextTrips';

export const DEFAULT_TIMEZONE = 'Europe/Moscow';
export const CLIENT_ID = 'metrika.28914540';

export {
  SubmitButton,
  FilterTag,
  FilterButton,
  Pad,
  Checkbox,
  Datepicker,
  GlobalErrorPlug,
  Carousel,
  CarouselButton,
  Loader,
  Info,
  Banner,
  NextTrips,
  useFade,
  useMediaQuery,
  capitalizeFirstLetter,
  displayPrice,
};
